export function getCardCategory(entry) {
    if (entry.isCommander)
        return 'commanders';
    const typeLine = entry.card.typeLine.toLowerCase();
    if (typeLine.includes('creature'))
        return 'creatures';
    if (typeLine.includes('instant'))
        return 'instants';
    if (typeLine.includes('sorcery'))
        return 'sorceries';
    if (typeLine.includes('enchantment'))
        return 'enchantments';
    if (typeLine.includes('artifact'))
        return 'artifacts';
    if (typeLine.includes('planeswalker'))
        return 'planeswalkers';
    if (typeLine.includes('battle'))
        return 'battles';
    if (typeLine.includes('land'))
        return 'lands';
    return 'other';
}
export function categorizeEntries(entries) {
    const result = {
        commanders: [],
        creatures: [],
        instants: [],
        sorceries: [],
        enchantments: [],
        artifacts: [],
        planeswalkers: [],
        battles: [],
        lands: [],
        other: [],
    };
    for (const entry of entries) {
        result[getCardCategory(entry)].push(entry);
    }
    return result;
}
export const CATEGORY_LABELS = {
    commanders: 'Commanders',
    creatures: 'Creatures',
    instants: 'Instants',
    sorceries: 'Sorceries',
    enchantments: 'Enchantments',
    artifacts: 'Artifacts',
    planeswalkers: 'Planeswalkers',
    battles: 'Battles',
    lands: 'Lands',
    other: 'Other',
};
//# sourceMappingURL=categorize.js.map